import { Localized } from '@fluent/react';
import { IconButton, Tooltip } from '@mui/material';

type ExportToExcelButtonProps = {
    onClick: () => void;
};

const ExcelIcon = () => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 64 64"
    fill="none"
  >
    {/* Dokument z wyciętym narożnikiem */}
    <path
      d="M12 4H48V20H64V60C64 61.1 63.1 62 62 62H14C12.9 62 12 61.1 12 60V4Z"
      fill="#ccc"
    />

    {/* Trójkąt zagięcia w pustej przestrzeni */}
    <polygon points="48,4 64,20 48,20" fill="#2f333e" />

    {/* Litera X */}
    <text
      x="32"
      y="44"
      textAnchor="middle"
      fontSize="28"
      fontWeight="bold"
      fill="#2f333e"
      fontFamily="Arial, sans-serif"
    >
      X
    </text>
  </svg>
);

export function GreenExcelIcon(props) {
    return <svg {...props} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
    <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"></path>
    <path fill="#FFF" d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z"></path>
    <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z"></path>
    <path fill="#FFF" d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z"></path>
</svg>
}

const ExportToExcelButton: React.FC<ExportToExcelButtonProps> = ({ onClick }) => {
    return (
        <Tooltip title={<Localized id='export-to-excel'>_Eksportuj do Excela</Localized>}>
            <IconButton sx={{
                [`& svg`]: {
                    width: '24px',
                    height: '24px',
                },
            }} onClick={onClick}>
                <GreenExcelIcon />
            </IconButton>
        </Tooltip >
    );
};

export default ExportToExcelButton;
